/**
 * Central stacking scale for overlay layers.
 *
 * antd v4 defaults: Modal/Drawer/Dropdown mask ~1000, Image preview wrap 1080.
 * Any overlay that must appear above an elevated drawer has to use a layer
 * from this scale instead of a hard-coded number.
 */
export const Z_INDEX = {
  /** Detail drawers elevated above base modals/dropdowns (antd default ~1000). */
  DRAWER: 1100,
  /** Modals opened from content rendered inside an elevated drawer. */
  MODAL_OVER_DRAWER: 1150,
  /** antd Image preview layers, raised above drawers via CSS overrides. */
  IMAGE_PREVIEW_MASK: 1200,
  IMAGE_PREVIEW_WRAP: 1201,
  IMAGE_PREVIEW_OPERATIONS: 1202,
} as const;
